<template>
<v-autocomplete
  v-model="select"
  :items="items"
  :loading="loading"
  :search-input.sync="search"
  hide-no-data
  no-filter
  return-object

  :menu-props="{ offsetY: true, fixed: true }"
  :label="$t('Standort')"
  :placeholder="placeholder"

  no-data-text="Keine passenden Orte gefunden"
  attach
  @change="change"
  filled

  clearable
></v-autocomplete>
</template>

<script>
import { GeocoderFactory } from "./Geocoder";

export default {
  name: "GeocoderAutocomplete",

  props: [
    "value",
    "placeholder",
    "hide-details"
  ],

  data() {
    return {
      loading: false,
      search: null,
      select: null,
      items: []
    };
  },

  created() {
    // Nicht reaktiv: Timer, Anfragezaehler und Geocoder je Komponenteninstanz
    this.timer = null;
    this.requestSeq = 0;
    this.isUnmounted = false;
    this.geocoder = null;
    this.geocoderReady = GeocoderFactory().then(geocoder => {
      this.geocoder = geocoder;
      return geocoder;
    });
  },

  beforeDestroy() {
    this.isUnmounted = true;
    this.stopPending();
  },

  watch: {
    search(val) {
      if (!val || (typeof val === "string" && val.trim() === "")) {
        this.stopPending();
        this.items = [];
        return;
      }

      if (val !== this.select && !(this.select && val === this.select.text)) {
        this.querySelections(val);
      }
    },

    value(val) {
      if (val) {
        this.select = val;
      }
    }
  },

  methods: {
    // Beendet Timer und laufende Anfrage und entwertet spaetere Antworten.
    stopPending() {
      if (this.timer != null) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.requestSeq++;

      if (this.geocoder) {
        this.geocoder.cancelAutocomplete();
      }

      this.loading = false;
    },

    querySelections(value) {
      this.stopPending();
      this.loading = true;

      const seq = this.requestSeq;

      this.timer = setTimeout(() => {
        this.timer = null;

        this.geocoderReady.then(geocoder => {
          if (this.isUnmounted || seq !== this.requestSeq) {
            return null;
          }
          return geocoder.autocomplete(value);
        }).then(items => {
          if (this.isUnmounted || seq !== this.requestSeq || !items) {
            return;
          }
          this.items = items.slice();
        }).catch(err => {
          if (!(err && err.cancelled) && seq === this.requestSeq) {
            console.warn("Geocoder search failed", err && err.message);
            this.items = [];
          }
        }).then(() => {
          if (!this.isUnmounted && seq === this.requestSeq) {
            this.loading = false;
          }
        });
      }, 150);
    },

    change(o) {
      this.stopPending();
      this.$emit("change", o);
    }
  }
};
</script>
